import { render, staticRenderFns } from "./importRecord.vue?vue&type=template&id=485317e5&scoped=true&"
import script from "./importRecord.vue?vue&type=script&lang=js&"
export * from "./importRecord.vue?vue&type=script&lang=js&"
import style0 from "./importRecord.vue?vue&type=style&index=0&id=485317e5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485317e5",
  null
  
)

export default component.exports